function addGeoDataLayer(map, source, layerId) {
    map.addLayer({
        'id': layerId,
        'type': 'fill',
        'source': source,
        'paint': {
            'fill-color': [
                'interpolate',
                ['linear'],
                ['get', 'numberOfClient'],
                0, '#f4cccc',
                5, '#f9cb9c',
                10, '#ffd966',
                15, '#6aa84f',
                20, '#134f5c',
                25, '#073763',
                30, '#2b0000'
            ],
            'fill-opacity': 0.75,
            'fill-outline-color': 'rgba(1, 1, 1 ,1)'
        }
    });
}

function addStatsLayer(map, id, key, source) {
    map.addLayer({
        'id': `data-${id}`,
        'type': 'fill',
        'source': source,
        'layout': {
            'visibility': 'none'
        },
        'paint': {
            'fill-color': [
                'interpolate',
                ['linear'],
                ['case',
                    // If the value is 'Unavailable', use 0
                    ['==', ['get', key], 'Unavailable'], 0,
                    // Otherwise, convert the string to a number
                    ['to-number', ['get', key]]
                ],
                0,
                '#e3c27b',
                0.05,
                '#d1c51d',
                0.1,
                '#b2eb15',
                0.15,
                '#55b519',
                0.2,
                '#42c9a1',
                0.25,
                '#139eba',
                0.3,
                '#0a63ab',
                0.45,
                '#5336e3',
                0.6,
                '#9536e3',
                0.75,
                '#a30bb8',
                0.9,
                '#b5144f'
            ],
            'fill-opacity': 0.70,
            'fill-outline-color': 'rgba(1, 1, 1 ,1)'
        }
    });
}

function addSA2FilterLayers(map, source) {
    const filters = {
        'ethnicity': 'maoriEthnicityPercent',
        'maori-descent': 'maoriDescent',
        'social-deprivation': 'socialDeprivation',
        'smoking': 'regularSmoker'
    };
    for (const [id, key] of Object.entries(filters)) {
        addStatsLayer(map, id, key, source);
    }
}

function addASADataLayers(map) {
    addGeoDataLayer(map, 'geo-data-asa', 'data-clientAddress');
}

function addPPWDataLayers(map) {
    addGeoDataLayer(map, 'geo-data-ppw', 'data-clientAddress');
}

function addPaeOraDataLayers (map) {
    addGeoDataLayer(map, 'geo-data-pae-ora', 'data-clientAddress');
}

function removeLayers(map) {
    try {
        // Collect all layers that need to be removed
        const layersToRemove = [];
        const layers = map.getStyle().layers;
        
        for (const layer of layers) {
            if (layer.id.startsWith('data-')) {
                layersToRemove.push(layer.id);
            }
        }
          // Remove all data layers first
        for (const layerId of layersToRemove) {
            try {
                if (map.getLayer(layerId)) {
                    map.removeLayer(layerId);
                }
            } catch (layerError) {
                // Layer removal failed, continue with others
            }
        }
        
        // Remove sources after all layers are removed
        const sources = ['geo-data-ppw', 'geo-data-asa', 'geo-data-pae-ora'];
        for (const sourceId of sources) {
            try {
                if (map.getSource(sourceId)) {
                    map.removeSource(sourceId);
                }
            } catch (sourceError) {
                // Source removal failed, continue with others
            }        }
    } catch (error) {
        // Error in removeLayers function
    }
}

export default {
    addASADataLayers,
    addPPWDataLayers,
    addPaeOraDataLayers,
    addSA2FilterLayers,
    removeLayers
}